import React, { useEffect, useRef, useState } from "react";
import CustomReactSelect from "../../../../../components/custom-react-select/CustomReactSelect";
import RegisterHeader from "../../../../../components/register-header/RegisterHeader";
import { Undo } from "@mui/icons-material";
import CustomModal from "../../../../../components/modal/CustomModal";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { ERROR, NO_RECORDS_FOUND, REGISTERS, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS } from "../../../../../utils/constants";
import { AppMisc } from "../../../../../misc/appMisc";
import AHMIS, { API_URL } from "../../../../../api/api";
import AddAlertMessage from "../../../../../components/alert/Alert";
import { useSelector } from "react-redux";

const DeletedRecords = () => {
  const [showUndoConformationModal, setShowUndoConformationModal] = useState(false);
  const { setValue, watch } = useForm()
  const [tableData, setTabledata] = useState([]);
  const [register, setRegister] = useState()
  const [mainData, setMainData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [undoId, setUndoId] = useState();
  const [page, setPage] = useState(0);
  const [getTableData, setGetTableData] = useState(false);
  const tableRef = useRef();
  const { fromDate, toDate, } = useSelector((state) => state.dateReducer);

  const getDeletedData = (fromDate, toDate, pageFromParam) => {
    let url = `${API_URL.deleteRecord}?fromDate=${fromDate}&toDate=${toDate}&registerType=${register}&pageNumber=${pageFromParam || (Number(page) + 1)}&rowSize=${ROW_PER_PAGE}`;
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTabledata(jsondata.data.objectList)
          setTotalSize(jsondata.data.size)
          setGetTableData(false);
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    if (fromDate && toDate) {
      getDeletedData(fromDate, toDate)
    }
  }, [fromDate, toDate])

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    setPage(0)
    getDeletedData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const openUndoModal = (id) => {
    setShowUndoConformationModal(true);
    setUndoId(id);
  }

  const undoRow = () => {
    AHMIS.get(`${API_URL.deleteRecord}/id?registerType=${register}&id=${undoId}`)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setPage(1);
          closeUndoConfirmationModal()
          setGetTableData(true);
          getDeletedData(fromDate, toDate)
          AddAlertMessage({ type: jsondata.type, message: jsondata.message })
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message })
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    register && setGetTableData(true);
  }, [register])

  const handleRegisterChange = (name, value) => {
    setRegister(value)
  }

  useEffect(() => {
    if (tableData !== null) {
      if (page > 1) {
        setMainData(tableData)
      } else {
        tableRef.current?.scrollTo(0, 0)
        setMainData(tableData)
      }
    }
  }, [tableData]);


  const closeUndoConfirmationModal = () => {
    setShowUndoConformationModal(false);
    setUndoId(null)
  }

  useEffect(() => {
    if (register) {
      getDeletedData(fromDate, toDate);
    }
  }, [register]);


  return (
    <>
      <RegisterHeader
        registerTitle="Deleted items"
        hideButton
        getRegisterData={getDeletedData}
        onHeaderParamChange={onHeaderParamChange}
        getTableData={getTableData}
      />
      <CustomReactSelect
        label="Registers"
        name="registers"
        options={REGISTERS}
        onChange={handleRegisterChange}
        isClearable={false}
        defaultValue={REGISTERS[0].value}
      />
      <Box mt={2}>
        <TableContainer>
          <Table classes={{ root: "table-bordered normal-spacing" }} id="deleted-records" size="small" aria-label="dleleted records table">
            <TableHead classes={{ root: "align-center" }}>
              <TableRow>
                <TableCell>मूल दर्ता नं.</TableCell>
                <TableCell>पुरा नाम</TableCell>
                <TableCell>Deleted By </TableCell>
                <TableCell>Deleted Reason </TableCell>
                <TableCell>Created Date </TableCell>
                <TableCell>Deleted Date </TableCell>
                <TableCell>Restore Data </TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {
                !tableData.length ? (
                  <TableRow>
                    <TableCell colSpan="7" size="medium">{NO_RECORDS_FOUND}</TableCell>
                  </TableRow>
                )
                  :
                  (
                    tableData.map(row => (
                      <TableRow key={row.id}>
                        <TableCell>{row.mulDartaaNumber || row.dartaaNumber || "-"}</TableCell>
                        <TableCell>{row?.fullName || (row.patientFirstName + " " + row.patientLastName)}</TableCell>
                        <TableCell>{row.deletedInfo.username}</TableCell>
                        <TableCell>{row.deletedInfo.deletedReason}</TableCell>
                        <TableCell>{row.createdDate && AppMisc.getDateLabelFromMillisecond(row.createdDate)}</TableCell>
                        <TableCell>{row.deletedInfo.deletedDate && AppMisc.getDateLabelFromMillisecond(row.deletedInfo.deletedDate)}</TableCell>
                        <TableCell>
                          <Tooltip title="यो रेकर्ड लाइ पुन: प्राप्त गर्न गर्नुहोस्।" placement="top" arrow>
                            <Box display="flex" justifyContent="space-around">
                              <IconButton onClick={() => openUndoModal(row.id)} aria-label="delete" color="secondary">
                                <Undo fontSize="small" />
                              </IconButton>
                            </Box>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <CustomModal
        title="Restore Data"
        onModalSubmit={() => undoRow()}
        showModal={showUndoConformationModal}
        onModalClose={closeUndoConfirmationModal}
        submitButtonText="Restore Record"
      >
        <Typography>
          के तपाइँ निश्चित हुनुहुन्छ कि तपाइँ यो रेकर्ड पुन: प्राप्त गर्न
          चाहनुहुन्छ?
        </Typography>
      </CustomModal>
    </>
  );
};

export default DeletedRecords; 